import { render } from "./SafeguardingPolicyContent.vue?vue&type=template&id=21e67bed&scoped=true"
const script = {}

import "./SafeguardingPolicyContent.vue?vue&type=style&index=0&id=21e67bed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e67bed"]])

export default __exports__